<template>
	
	<div @click.prevent="onClick" @dblclick="onDoubleClick">
		
		<TicketTitle :ticket="ticket" :class="{ 'no-margin': !showDescription }"/>
		
		<p v-if="showCategory" title="Category" class="ticket__detail"><ion-icon name="checkbox"></ion-icon>{{ ticket.type }}</p>
		
		<p v-if="showComments" title="Comments" class="ticket__detail"><ion-icon name="chatboxes"></ion-icon>{{ comments }}</p>
		
		<div v-if="showDescription" class="description" v-html="ticket.description"></div>
		
	</div>
	
</template>

<script>
	
	import TicketTitle from "@/components/TicketTitle";
	
	export default {
		
		components: { TicketTitle },
		
		props: {
			ticket: { default() { return {}; } },
			showCategory: { default: false },
			showComments: { default: false },
			showDescription: { default: true },
		},
		
		computed: {
			
			comments() {
				if (this.ticket.comments.length) {
					if (this.ticket.comments.length > 1) {
						return `${this.ticket.comments.length} comments`;
					}
					return "1 comment";
				}
				return "No comments";
			}
			
		},
		
		methods: {
			
			onClick(e) {
				this.$emit("on-click", { ticket: this.ticket });
			},
			
			onDoubleClick(e) {
				this.$emit("on-click", { ticket: this.ticket, doubleClick: true });
			},
			
		},
		
		created() {
			
		}
		
	}
	
</script>

<style scoped>
	
	p,
	/deep/ .description p:last-of-type {
		margin-bottom: 0;
	}
	
</style>


// WEBPACK FOOTER //
// src/components/TicketDetails.vue